<div [style]="{'display': 'flex'}">
    <div>
        <div class="py-2 float-left">
            <h3 class="first">Campaign External IDs</h3>
        </div> 
    
        <div class=" pt-4 d-flex flex-column col-md-12">
            <p class="external-ids-override-p">Override</p>
            <div class="col-md-12 py-2 d-flex flex-row" *ngIf="!isOASCampaign">
                <label class="my-auto col-md-4">DV360</label>
                <p-inputNumber [disabled]="true" [ngModel]="DV360_Campaign_ID" [useGrouping]="false" emptyValue="empty"></p-inputNumber>
                <p-inputSwitch (onChange)="changeStatus($event, 'dv360')" class="external-ids-input-switch" [(ngModel)]="overrideDV360"></p-inputSwitch>
                <p-inputNumber [disabled]="!overrideDV360" [useGrouping]="false" [(ngModel)]="DV360_Campaign_ID_External" emptyValue="empty"></p-inputNumber>
            </div>
    
            <div class="col-md-12 py-2 d-flex flex-row">
                <label class="my-auto col-md-4">GCM</label>
                <p-inputNumber [disabled]="true" [ngModel]="GCM_Campaign_ID" [useGrouping]="false" emptyValue="empty"></p-inputNumber>
                <p-inputSwitch (onChange)="changeStatus($event, 'gcm')" class="external-ids-input-switch" [(ngModel)]="overrideGCM"></p-inputSwitch>
                <p-inputNumber [disabled]="!overrideGCM" [useGrouping]="false" [(ngModel)]="GCM_Campaign_ID_External" emptyValue="empty"></p-inputNumber>
            </div>
            
            <div class="col-md-12 py-2 d-flex flex-row" *ngIf="!isOASCampaign">
                <label class="my-auto col-md-4">TTD</label>
                <input [disabled]="true" [value]="TTD_Campaign_ID" type="text" placeholder="" pInputText>
                <p-inputSwitch (onChange)="changeStatus($event, 'ttd')" class="external-ids-input-switch" [(ngModel)]="overrideTTD"></p-inputSwitch>
                <input type="text" [disabled]="!overrideTTD" [(ngModel)]="TTD_Campaign_ID_External" placeholder="" pInputText>
            </div>

            <div class="col-md-12 py-2 d-flex flex-row" *ngIf="isOASCampaign">
                <label class="my-auto col-md-4">GAM LineItem ID</label>
                <input [disabled]="true" type="text" placeholder="" pInputText [value]="GAM_LineItem_ID">
                <p-inputSwitch (onChange)="changeStatus($event, 'gam_line_item')" class="external-ids-input-switch" [(ngModel)]="overrideGAMLineItem"></p-inputSwitch>
                <input type="text" [disabled]="!overrideGAMLineItem" [(ngModel)]="GAM_Line_Item_ID_External" placeholder="" pInputText>
            </div>
    
            <div class="col-md-12 py-2 d-flex flex-row" *ngIf="isOASCampaign">
                <label class="my-auto col-md-4">GAM Order ID</label>
                <p-inputNumber [disabled]="true" [ngModel]="GAM_Campaign_ID" [useGrouping]="false" emptyValue="empty"></p-inputNumber>
                <p-inputSwitch (onChange)="changeStatus($event, 'gam_order')" class="external-ids-input-switch" [(ngModel)]="overrideGAMOrder"></p-inputSwitch>
                <p-inputNumber [disabled]="!overrideGAMOrder" [useGrouping]="false" [(ngModel)]="GAM_Order_ID_External" emptyValue="empty"></p-inputNumber>
            </div>
            
            <div class="col-md-12 py-2 d-flex flex-row" *ngIf="!isOASCampaign">
                <label class="my-auto col-md-4">Meta</label>
                <p-inputNumber [disabled]="true" [ngModel]="Meta_Campaign_ID" [useGrouping]="false" emptyValue="empty"></p-inputNumber>
                <p-inputSwitch (onChange)="changeStatus($event, 'meta')" class="external-ids-input-switch" [(ngModel)]="OverrideMeta"></p-inputSwitch>
                <p-inputNumber [disabled]="!OverrideMeta" [useGrouping]="false" [(ngModel)]="Meta_Campaign_Id_External" emptyValue="empty"></p-inputNumber>
            </div>
            
        </div>
    </div>
    <div style="position: relative; width: 100%;">
        <button (click)="save()" pButton class="px-3 edge-button" style="position:absolute; right: 25px; bottom: 0;" label="Save"></button>
    </div>
    

</div>